import React from 'react'
import ManageNotifications from '../../../components/AdminNotifications/ManageNotifications'

const NotificationsPage = () => {
    return (
        <div class="w-full">
            <ManageNotifications />
        </div>
    )
}

export default NotificationsPage
